import React, { FC } from "react";
import { Link, RouteComponentProps } from "@reach/router";
import styled from "styled-components";
import { ThemeProps } from "../styles/theme";

interface NotFound404Props extends RouteComponentProps {
    type?: "card";
    id?: string;
}

const Container = styled.div<ThemeProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: ${props => props.theme.primaryBackground || '#f9f9f9'};
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

const Content = styled.div<ThemeProps>`
    text-align: center;
    padding: 2rem;
    max-width: 600px;
    background-color: ${props => props.theme.primaryBackground || 'white'};
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    border: ${props => props.theme.primaryBorder || '#e0e0e0'} 1px solid;
`;

const Title = styled.h1<ThemeProps>`
    font-size: 6rem;
    margin: 0;
    color: ${props => props.theme.error ?? '#d32f2f'};
    line-height: 1;
`;

const Subtitle = styled.h2<ThemeProps>`
    font-size: 2rem;
    margin: 0.5rem 0 1.5rem;
    color: ${props => props.theme.primaryText || '#424242'};
`;

const Message = styled.div<ThemeProps>`
    margin: 2rem 0;
    color: ${props => props.theme.secondaryText || '#616161'};
    font-size: 1.1rem;
    line-height: 1.6;
    
    code {
        background-color: ${props => props.theme.cardShadow || '#f5f5f5'};
        padding: 0.2rem 0.4rem;
        border-radius: 3px;
        font-family: 'Courier New', Courier, monospace;
        font-size: 0.9em;
    }
`;

const ActionLinks = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 2rem;
`;

// Используем другой подход для стилизации Link из @reach/router
const LinkButton = styled.div<ThemeProps>`
    display: inline-block;
    padding: 0.8rem 1.5rem;
    background-color: ${props => props.theme.accentColor || '#2196f3'};
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 500;
    transition: background-color 0.2s ease;
    
    a {
        color: inherit;
        text-decoration: none;
    }
    
    &:hover {
        background-color: ${props => props.theme.accentColorDark ?? '#1976d2'};
    }
`;

const NotFound404: FC<NotFound404Props> = ({ type = "resource", id }) => {
    return (
        <Container>
            <Content>
                <Title>404</Title>
                <Subtitle>Resource Not Found</Subtitle>
                
                <Message>
                    {type === "card" && id !== undefined && id !== '' && (
                        <p>Sorry, the card with ID <code>{id}</code> was not found.</p>
                    )}

                    {(type === undefined || type === null || type === "resource") && (
                        <p>The requested resource was not found.</p>
                    )}
                </Message>
                
                <ActionLinks>
                    <LinkButton>
                        <Link to="/search">Search Cards</Link>
                    </LinkButton>
                    <LinkButton>
                        <Link to="/">Home</Link>
                    </LinkButton>
                </ActionLinks>
            </Content>
        </Container>
    );
};

export { NotFound404 };
